import React from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui';
const TestimonialCard = ({
  name,
  text,
  initials,
  image
}: {
  name: string;
  text: React.ReactNode;
  initials: string;
  image?: string;
}) => <div className="bg-white p-4 md:p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full hover:shadow-md transition-shadow" data-id="element-305">
    <div className="flex text-brand-gold mb-2" data-id="element-306">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-307" />)}
    </div>
    <p className="text-gray-700 italic flex-grow text-lg mb-6 leading-relaxed" data-id="element-308">
      "{text}"
    </p>
    <div className="flex items-center gap-4 mt-auto pt-4 border-t border-gray-50" data-id="element-309">
      {image ? <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover flex-shrink-0" data-id="element-310" /> : <div className="w-12 h-12 bg-brand-teal/10 rounded-full flex items-center justify-center text-brand-teal font-bold text-lg" data-id="element-311">
          {initials}
        </div>}
      <div data-id="element-312">
        <p className="font-bold text-brand-charcoal" data-id="element-313">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-314">Mamá verificada</p>
      </div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-10 md:py-20 px-4 bg-brand-cream" data-id="element-315">
      <div className="max-w-6xl mx-auto" data-id="element-316">
        <div className="text-center mb-8 md:mb-16" data-id="element-317">
          <h2 className="font-nunito font-extrabold text-3xl md:text-5xl text-brand-charcoal mb-4" data-id="element-318">
            No Te Quedo Con Mi Palabra. <br className="hidden md:block" data-id="element-319" />
            <span className="text-brand-teal" data-id="element-320">Escuchá a Otras Mamás:</span>
          </h2>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-321">
            Mamás reales. Resultados reales. Sin filtro.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-322">
          <TestimonialCard initials="DR" name="Daniela R., mamá de Mateo (4 años), Buenos Aires" image="https://cdn.magicpatterns.com/uploads/bZ6YXLCiGs3Nv2ZtczZCYG/2585988-selfie-young-woman-and-casual-in-park-walking-and-smile-for-fun-balance-and-happiness.-portrait-female-and-lady-with-joy-summer-and-chilling-outdoor-cheerful-and-freedom-on-break-and-weekend-fit_400_400.jpg" text={<>
                Llevaba 8 meses con el mismo problema. Probé todo lo que me
                recomendaron y nada. A los 3 días de aplicar el plan,{' '}
                <strong data-id="element-324">
                  mi hijo fue solo al baño por primera vez sin llorar
                </strong>
                . Yo lloré de alegría.{' '}
                <em data-id="element-325">
                  Esta guía debería dársela a cada mamá en el consultorio
                  pediátrico.
                </em>
              </>} data-id="element-323" />
          <TestimonialCard initials="CM" name="Cecilia M., mamá de Tomás (5 años), Córdoba" image="https://cdn.magicpatterns.com/uploads/9N8jZa8mxiHAZCgRR5SbEu/premium_photo-1661594909295-1ba7e9078696.jpg" text={<>
                Lo que más me ayudó fue entender que{' '}
                <strong data-id="element-327">NO era culpa mía</strong> y que{' '}
                <strong data-id="element-328">NO era capricho de él</strong>. Cuando dejé de pelear y
                empecé a acompañar, todo cambió. La guía me dio las palabras y
                el plan que necesitaba. Gracias de verdad.
              </>} data-id="element-326" />
          <TestimonialCard initials="LF" name="Luciana F., mamá de Sofía (3 años), Rosario" image="https://cdn.magicpatterns.com/uploads/hzhcW7Y5asFRqe6UAibktY/shutterstock-214228522_orig.jpg" text={<>
                Mi pediatra me mandaba a casa siempre con el mismo consejo: más
                fibra y más agua. Nada.{' '}
                <strong data-id="element-330">
                  Esta guía me explicó en 30 minutos lo que ningún médico me
                  explicó en 2 años.
                </strong>{' '}
                No puedo creer que sea tan accesible.
              </>} data-id="element-329" />
          <TestimonialCard initials="MV" name="Marina V., mamá de Emma (4 años), Mendoza" image="https://cdn.magicpatterns.com/uploads/mN5gyNmTJ8hQjdcKDjdtfs/cozy-family-portraits.jpg.jpg" text={<>
                Sentía que estaba fallando como mamá. Que era la única. Que algo
                estaba muy mal.{' '}
                <em data-id="element-332">Esta guía me abrazó desde la primera página.</em> Y el plan
                funciona.{' '}
                <strong data-id="element-333">Mi hija lleva 3 semanas yendo sin drama.</strong> Tres
                semanas. No lo podía creer.
              </>} data-id="element-331" />
        </div>

        <div className="mt-8 md:mt-16 text-center" data-id="element-334">
          <Button className="text-xl py-4 px-8 md:py-5 md:px-10" data-id="element-335">
            ✅ Quiero Los Mismos Resultados →
          </Button>
        </div>
      </div>
    </section>;
};